import { useParams } from "react-router";
import _ from "lodash";

import { colors } from "theme/palette";

import Stack from "components/Stack";
import Text from "components/Text";

import { useOnboardingCompanyPackageCategorizedFileFieldCounts } from "entities/Deal/sdk";

import CategoryTag from "./CategoryTag";

const OnboardingChecklistFieldCategories = () => {
  const params = useParams<{
    dealId: string;
    packageId: string;
  }>();
  const dealId = Number(params.dealId);
  const packageId = Number(params.packageId);

  const {
    data: onboardingCompanyPackageCategorizedFileFieldCounts,
    isLoading: isLoadingOnboardingCompanyPackageCategorizedFileFieldCounts,
  } = useOnboardingCompanyPackageCategorizedFileFieldCounts({
    dealId,
    companyPackageId: packageId,
  });

  const isLoading =
    _.isNil(onboardingCompanyPackageCategorizedFileFieldCounts) ||
    isLoadingOnboardingCompanyPackageCategorizedFileFieldCounts;

  return (
    <Stack>
      <Text variant="labelSmall" color={colors.gray40} marginBottom={1}>
        PROGRESS OF AI DATA EXTRACTION FROM DOCUMENTS
      </Text>

      <Stack gap={0.5} direction="row" flexWrap="wrap">
        <CategoryTag
          isLoading={isLoading}
          backgroundColor={colors.red40}
          text="missing"
          circleBackgroundColor={colors.black}
          count={onboardingCompanyPackageCategorizedFileFieldCounts?.missing}
        />
        <CategoryTag
          isLoading={isLoading}
          backgroundColor={colors.blue40}
          circleBackgroundColor={colors.black}
          count={
            onboardingCompanyPackageCategorizedFileFieldCounts?.categorized
          }
          text="categorized"
        />
        <CategoryTag
          isLoading={isLoading}
          backgroundColor={colors.blue80}
          circleBackgroundColor={colors.white}
          text="AI extracted"
          color={colors.white}
          count={
            onboardingCompanyPackageCategorizedFileFieldCounts?.ai_extracted
          }
        />
        <CategoryTag
          isLoading={isLoading}
          backgroundColor={colors.blue120}
          circleBackgroundColor={colors.white}
          text="reviewed"
          color={colors.white}
          count={onboardingCompanyPackageCategorizedFileFieldCounts?.reviewed}
        />
      </Stack>
    </Stack>
  );
};

export default OnboardingChecklistFieldCategories;
